import { observer } from "mobx-react-lite";
import { useStore } from "../../../stores";
import { ChatChannel } from "../../../models";
import Message from "./Message";
import { useMemo } from "react";

const MessageReplies = ({ mId }: { mId?: string }) => {
  const { selectedChat } = useStore("chats");
  const { messages } = useStore("chats");

  const replies = useMemo(() => {
    if (selectedChat?.channel !== ChatChannel.FBComment || !mId) {
      return [];
    }
    return messages.filter((f) => f.mId?.includes("|") && f.mId?.includes(mId));
  }, [messages, mId, selectedChat?.channel]);

  if (replies.length === 0) {
    return null;
  }

  return (
    <div className="is-flex is-justify-content-flex-end">
      <div className="is-flex-grow-1">
        {replies.map((reply) => (
          <Message key={reply.id} message={reply} noReplies />
        ))}
      </div>
    </div>
  );
};

export default observer(MessageReplies);
